import script from "./ForecastAccuracyHistoryModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForecastAccuracyHistoryModal.vue?vue&type=script&setup=true&lang=ts"

import "./ForecastAccuracyHistoryModal.vue?vue&type=style&index=0&id=526740db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526740db"]])

export default __exports__